import type { TNumberedListElement } from '@shared/dream-components';
import { NumberedListElement } from '@shared/dream-components';
import type { ReactNode } from 'react';

interface Props {
  node: TNumberedListElement;
  children: ReactNode | ReactNode[];
}

export const OrderedList = ({ node, children }: Props) => {
  return <NumberedListElement element={node}>{children}</NumberedListElement>;
};
